import { render, staticRenderFns } from "./zrdata.vue?vue&type=template&id=cfc1b3c6&scoped=true&"
import script from "./zrdata.vue?vue&type=script&lang=js&"
export * from "./zrdata.vue?vue&type=script&lang=js&"
import style0 from "./zrdata.vue?vue&type=style&index=0&id=cfc1b3c6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfc1b3c6",
  null
  
)

export default component.exports